import { useState } from "react";
import { useAppDispatch } from "../../../redux-tool-kit/Hooks";
import { Form, FormGroup, Input, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import CommonDropDown from "../CommonDropDown";
import { SearchBoxProps } from "../../../types/organization/OrganizationList";

const SearchBox = ({
  showUserActions = false,
  onAddUser,
  onInvite,
}: SearchBoxProps) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleSearchKeyword = (keyword: string) => {
    setSearchKeyword(keyword);
  };
  return (
    <div className="search-box-container d-flex align-items-center">
      <Form style={{ flex: 1, marginBottom: 0 }}>
        <FormGroup className="form-group m-0">
          <Input
            type="search"
            placeholder={t("Search")}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <i className="fa fa-search"></i>
        </FormGroup>
      </Form>
      <div className="d-flex align-items-center gap-2">
        {showUserActions && (
          <>
            <Button
              className="text-white btn btn-info no-radius custom-action-btn"
              color="primary"
              style={{
                minHeight: "35px",
                fontSize: "0.90rem",
                padding: "0 20px",
              }}
              onClick={onAddUser}
              type="button"
            >
               <i className="fa fa-plus me-2"></i>
              {t("New")}
            </Button>
            <Button
              className="text-white btn btn-info no-radius custom-action-btn"
              color="secondary"
              style={{
                minHeight: "35px",
                fontSize: "0.90rem",
                padding: "0 20px",
              }}
              onClick={onInvite}
              type="button"
            >
              {t("Invite")}
            </Button>
          </>
        )}
        <div className="search-dropdown">
          <CommonDropDown color="info" />
        </div>
      </div>
    </div>
  );
};

export default SearchBox;
